import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppUtils } from '@gscope-mfe/app-bridge';
import CommonLngs from './CommonLngs';
import i18next from 'i18next';

export { default as i18next } from 'i18next';

//Handles the change of language in the app
export const changeLanguage = (lang) => {
    return new Promise((resolve, reject) => {
        i18next
            .changeLanguage(lang)
            .then((t) => {
                resolve(true);
            })
            .catch((e) => {
                reject(false);
            });
    });
};

export const localizeLang = () => {
    const { moduleName } = AppUtils.get();
    const { t } = moduleName ? useTranslation(moduleName) : useTranslation();
    return t;
};
export const localizeCommonLang = () => {
    const { t } = useTranslation();
    return t;
};
export const loadI18n = (langs) => {
    const { moduleName, setAllLangs } = AppUtils.get();
    const { t, i18n } = moduleName ? useTranslation(moduleName) : useTranslation();
    const [isInitialized, setIsInitialized] = React.useState(false);
    React.useEffect(() => {
        if (isInitialized) {
            return;
        }
        if (moduleName && Array.isArray(langs) && langs.length) {
            const commonNs = 'common';
            const allSupported = langs.reduce((acc, lang) => {
                if (Array.isArray(lang) && lang.length === 2) {
                    if (CommonLngs[lang[0]]) {
                        i18n.addResources(lang[0], commonNs, CommonLngs[lang[0]]);
                    }

                    i18n.addResources(lang[0], moduleName, lang[1]);
                    acc.push(lang[0]);
                }

                return acc;
            }, []);
            setAllLangs(allSupported);
            setIsInitialized(true);
        }
    }, [moduleName, langs.length]);
    return t;
};

export const loadLangCommon = (langs, namespace) => {
    const { t } = useTranslation(namespace);
    for (let lang of langs) {
        i18next.addResourceBundle(lang[0], namespace, lang[1]);
    }
    return t;
};

//Returns the translation function when a custom namespace is passed
export const localizeCustomNameSpace = (namespace) => {
    const { t } = useTranslation(namespace);
    return t;
};
